import { render, staticRenderFns } from "./qualityandenvpolicy.vue?vue&type=template&id=428823df&"
import script from "./qualityandenvpolicy.vue?vue&type=script&lang=js&"
export * from "./qualityandenvpolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports